import { useMutation } from '@apollo/client';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';
import { SUBMIT_DATA_DELETION_REQUEST } from 'graphql/service';

export const useSubmitDataDeletionRequest = () => {
  const { showGlobalMessage, showGlobalError } = useGlobalAlerts();

  const [submitMutation, { loading }] = useMutation(SUBMIT_DATA_DELETION_REQUEST);

  const submitDataDeletionRequest = async (
    email?: string,
    phoneNumber?: string
  ) => {
    try {
      const res = await submitMutation({
        variables: {
          data: {
            email,
            phoneNumber,
            confirmedTerms: true,
          },
        },
      });

      if (res?.data?.submitDataDeletionRequest) {
        showGlobalMessage(
            'Your request has been submitted successfully. Please check your email or phone for the confirmation instructions.'
        );
        return res.data.submitDataDeletionRequest;
      }

      return null;
    } catch (error: any) {
      showGlobalError(
        error?.message || 'Failed to submit the deletion request.'
      );
      return null;
    }
  };

  return {
    submitDataDeletionRequest,
    loading,
  };
};